import { base44 } from "@/api/base44Client";

/**
 * logAttendanceScan
 * Writes a single row to the `AttendanceScanLog` collection. Fire-and-forget;
 * errors are swallowed so a logging failure never breaks an attendance mark.
 *
 * @param {Object} row
 * @param {string} row.studentId    Student ID / other_id
 * @param {string} row.studentName  "First Last"
 * @param {"ea"|"asd"} row.rosterType
 * @param {"present"|"absent"|"excused"|"refusal"|"pending"} row.status
 * @param {"barcode_scan"|"manual_entry"} row.method
 */
/**
 * resolveEaAttendance
 * Credits an EA-present event to the matching `ea_miss_trackings` row so
 * active EA assignments actually get resolved and stop triggering ASD.
 * Fire-and-forget from the frontend so a hook failure never blocks the mark.
 *
 * @param {string} otherId Student barcode / badge id
 * @param {string} [logDate] "yyyy-MM-dd" — defaults to today on the server
 */
export const resolveEaAttendance = (otherId, logDate) => {
  if (!otherId) return Promise.resolve();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  return fetch(`${BACKEND_URL}/api/closeout/resolve-ea-attendance`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ other_id: otherId, log_date: logDate }),
  }).catch((e) => console.warn("resolveEaAttendance skipped:", e?.message || e));
};

export const logAttendanceScan = ({ studentId, studentName, rosterType, status, method }) =>
  base44.entities.AttendanceScanLog
    .create({
      student_id: studentId,
      student_name: studentName,
      roster_type: rosterType,
      status,
      method,
      timestamp: new Date().toISOString(),
    })
    .catch((e) => console.warn("AttendanceScanLog write skipped:", e?.message || e));

/**
 * logAttendanceScanBulk — helper for bulk marks. Same shape, but `.bulkCreate`.
 * @param {Array} rows
 */
export const logAttendanceScanBulk = (rows) => {
  if (!rows?.length) return Promise.resolve();
  const now = new Date().toISOString();
  const payload = rows.map((r) => ({
    student_id: r.studentId,
    student_name: r.studentName,
    roster_type: r.rosterType,
    status: r.status,
    method: r.method,
    timestamp: r.timestamp || now,
  }));
  return base44.entities.AttendanceScanLog
    .bulkCreate(payload)
    .catch((e) => console.warn("AttendanceScanLog bulk write skipped:", e?.message || e));
};
